module.exports = __webpack_public_path__ + "static/media/LandingApps.1d557117.svg";